import Link16 from '@carbon/icons-react/es/link/16';
import Unlink16 from '@carbon/icons-react/es/unlink/16';
import { Space, Typography } from 'antd';
import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/atoms/button';
import { Loading } from 'components/atoms/loading';
import { useUsersMapQuery } from 'queries/members';
import { logger } from 'services';
import { Divider, Heading } from '../authenticate.styles';
import { ConnectedProps } from './connected.types';

const { Text } = Typography;

export const Connected = ({
  handleDisconnect,
  isDisconnecting,
  authenticatedBy,
}: ConnectedProps) => {
  const [showDisconnect, setShowDisconnect] = useState(false);

  const { data: userMap, isLoading } = useUsersMapQuery();
  const authenticatedUser =
    authenticatedBy?.userId !== undefined
      ? userMap?.get(authenticatedBy?.userId)
      : null;

  const handleMouseEvents = useCallback(
    (status = false) => {
      setShowDisconnect(status);
    },
    [setShowDisconnect],
  );

  if (!authenticatedBy) {
    logger.log('Authenticated user info is missing');
  }

  return (
    <>
      <Heading>
        <FormattedMessage id="settings.integrations.slack.authenticate.title" />
      </Heading>

      <Space direction="vertical" size={4} align="start">
        <Button
          type="primary"
          icon={showDisconnect ? <Unlink16 /> : <Link16 />}
          iconPlacement="right"
          onClick={handleDisconnect}
          onMouseEnter={() => handleMouseEvents(true)}
          onMouseLeave={() => handleMouseEvents(false)}
          danger={!!showDisconnect}
          loading={isDisconnecting}
        >
          {showDisconnect ? (
            <FormattedMessage id="disconnect" />
          ) : (
            <FormattedMessage id="connected" />
          )}
        </Button>

        {!isLoading ? (
          <Text>
            <FormattedMessage
              id="settings.integrations.slack.authenticate.connected.as"
              values={{ connector: <b>{authenticatedUser?.emailId || ''}</b> }}
            />
          </Text>
        ) : (
          <Loading />
        )}
      </Space>
      <Divider />
    </>
  );
};
